module.exports = {
      id: "astrology-usage",
      viewBox: "0 0 29.4 29.4",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#astrology",
      toString: function () {
        return this.url;
      }
    }